import { T } from "@supersig/validate";
import { z } from "zod";
/** @internal */ export function createIdSchema(prefix) {
    return z.string().refine((id)=>{
        if (!id.startsWith(`${prefix}:`)) {
            throw new Error(`${prefix} ID must start with "${prefix}:"`);
        }
        return true;
    }).transform((id)=>{
        // Perform any additional transformation if needed, or directly return
        return id;
    });
}
/** @internal */ export function idValidator(prefix) {
    return T.string.refine((id)=>{
        if (!id.startsWith(`${prefix}:`)) {
            throw new Error(`${prefix} ID must start with "${prefix}:"`);
        }
        return id;
    });
}
